import { useQuery } from '@tanstack/react-query';
import type { PaginatedResponse } from '../types/domain';
import { apiRequest } from './api';

export interface ApiCollectionQueryOptions {
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
}

export function useApiCollection<T, TResponse = PaginatedResponse<T>>(
  resource: string,
  path: string,
  accessToken: string | null,
  enabled = true,
  queryOptions: ApiCollectionQueryOptions = {},
) {
  return useQuery({
    queryKey: ['collection', resource, path, accessToken],
    enabled: enabled && Boolean(accessToken),
    queryFn: () => apiRequest<TResponse>(path, accessToken ? { accessToken } : {}),
    ...queryOptions,
  });
}
